var map = {
	"./common/basic-aside.vue": [
		1973,
		983
	],
	"./common/basic-footer.vue": [
		6928,
		174
	],
	"./common/basic-header-profile.vue": [
		8437,
		781
	],
	"./common/basic-header.vue": [
		1957,
		972
	],
	"./common/basic-layout.vue": [
		5367,
		163
	],
	"./common/blank-layout.vue": [
		9552,
		578
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 507;
module.exports = webpackAsyncContext;